import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { CategoryService } from '../../../core/services/category.service';
import {NzMessageService} from "ng-zorro-antd/message";

@Component({
  selector: 'app-add-edit-categories',
  templateUrl: './add-edit-categories.component.html',
  styleUrls: ['./add-edit-categories.component.scss'],
})
export class AddEditCategoriesComponent implements OnInit {
  @Input() entryType?: string;
  @Input() categoryId?: any;
  @Input() currentName: any;
  isButtonLoading = false;
  name = "";

  constructor(
    private modal: NzModalRef,
    private categoryService: CategoryService,
    private nzMessageService: NzMessageService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
      this.name = this.currentName;
  }

  handleCancel(): void {
    this.modal.close({ message: 'error' });
  }

  async editCategory(): Promise<void> {
    this.isButtonLoading = true;
    try {
      await this.categoryService.updateCategory({_id: this.categoryId, name: this.name });
      this.nzMessageService.success(
        this.translocoService.translate('settings.shared.addEditCategories.messages.updated')
      );
      this.isButtonLoading = false;
      this.modal.close({ message: "success" });
    } catch (error: any) {
      this.isButtonLoading = false;
      this.nzMessageService.error(error.message.message);
      this.modal.close({ message: "error" });
    }
  }

  async addNewCategory(): Promise<void> {
    this.isButtonLoading = true;
    try {
      await this.categoryService.createCategory({ name: this.name });
      this.nzMessageService.success(
        this.translocoService.translate('settings.shared.addEditCategories.messages.added')
      );
      this.isButtonLoading = false;
      this.modal.close({ message: "success" });
    } catch (error: any) {
      this.isButtonLoading = false;
      this.nzMessageService.error(error.message.message);
      this.modal.close({ message: "error" });
    }
  }
}
